module.exports = __webpack_public_path__ + "img/header-diamondJewelryDelicateJewels.3a8dc0b.jpg";